import type { ApiResponse } from './types'

export class ApiError extends Error {
  constructor(response: ApiResponse) {
    super(response.msg || 'Что-то пошло не так')
    this.name = 'ApiError'
  }
}
